// custom-instance.ts
import { checkBaseUrlSlash } from "@pga/utils/checkUrlSlash/checkUrlSlash";
import axios from "axios";
export const AUTH_AXIOS_INSTANCE = (signal, baseURL, callExportGrid) => {
    const BASE_URL = baseURL !== null && baseURL !== void 0 ? baseURL : checkBaseUrlSlash();
    return axios.create({
        withCredentials: false,
        baseURL: BASE_URL,
        responseType: callExportGrid ? "arraybuffer" : undefined,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": callExportGrid ? "application/json" : undefined,
        },
        signal: signal,
    });
};
